/* Creazione delle icone per la scelta del mezzo */
import React, { Component } from 'react';
import FlightIcon from '@material-ui/icons/Flight'
import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import DirectionsWalkIcon from '@material-ui/icons/DirectionsWalk';
import DirectionsBusIcon from '@material-ui/icons/DirectionsBus';
import DirectionsBoatIcon from '@material-ui/icons/DirectionsBoat';
import Tooltip from '@material-ui/core/Tooltip';
import { Trans } from 'react-i18next';

export default class GroupButton extends Component {
    constructor(props){
        super(props);
        this.state = {
            walk: {
                active: false
            },
            airplane: {
                active: false
            },
            bike: {
                active: false
            },
            ferry: {
                active: false
            },
            common: {
                active: true
            }
        }
        this.handleClick = this.handleClick.bind(this);


        }

        handleClick(mezzo) {    
            this.speghi(mezzo)
            this.props.callback(mezzo);
        }

        speghi(mezzo) {
            
            this.setState(function() {
                return {
                    walk: {
                        active: false
                    },
                    airplane: {
                        active: false
                    },
                    bike: {
                        active: false
                    },
                    ferry: {
                        active: false
                    },
                    common: {
                        active: false
                    }
                };
            })
            this.setState(function() {
                return {
                    [mezzo]: {
                        active: true
                    }
                }
            })
        }
        
    render(){
        return (   
            <div className={'flex-container1'}>
                <button className={'switchButtonStyle'} style={{backgroundColor: this.state.common.active ? "#BD0518" : "lightgray"}} onClick={() => this.handleClick("common")}>
                <DirectionsBusIcon style={{color: this.state.common.active ? "white" : "black", fontSize: 12}} />
                <DirectionsBoatIcon style={{color: this.state.common.active ? "white" : "black", fontSize: 12}} />
                </button>
                <button className={'switchButtonStyle'} style={{backgroundColor: this.state.walk.active ? "#BD0518" : "lightgray"}} onClick={() => this.handleClick("walk")}>
                <DirectionsWalkIcon style={{color: this.state.walk.active ? "white" : "black", fontSize: 18}} />
                </button>
                <button className={'switchButtonStyle'} style={{backgroundColor: this.state.bike.active ? "#BD0518" : "lightgray"}} onClick={() => this.handleClick("bike")}>
                <DirectionsBikeIcon style={{color: this.state.bike.active ? "white" : "black", fontSize: 18}}/>
                </button>
                <Tooltip title={<Trans>Indicare un punto nelle immediate vicinanze dell' aeroporto</Trans>}>
                <button className={'switchButtonStyle'} style={{backgroundColor: this.state.airplane.active ? "#BD0518" : "lightgray"}} onClick={() => this.handleClick("airplane")}>
                <FlightIcon style={{color: this.state.airplane.active ? "white" : "black", fontSize: 18}}/>
                </button>
                </Tooltip>
                <Tooltip title={<Trans>Indicare un punto nelle immediate vicinanze del porto</Trans>}>
                <button className={'switchButtonStyle'} style={{backgroundColor: this.state.ferry.active ? "#BD0518" : "lightgray"}} onClick={() => this.handleClick("ferry")}>
                <DirectionsBoatIcon style={{color: this.state.ferry.active ? "white" : "black", fontSize: 18}}/>
                </button>
                </Tooltip>
            </div> )    
        }
}